import "./PhotoMosaic.css";

const getPhotoSrc = (photo) => photo?.image_data || photo?.src || "";
const getPhotoTitle = (photo, index) => photo?.title || photo?.alt || `Style ${index + 1}`;
const getFrameClass = (photo) => {
  const text = `${photo?.category || ""} ${photo?.title || ""} ${photo?.label || ""}`.toLowerCase();
  if (/(barbe|contour|detail|finition|texture)/.test(text)) return "pm-frame--detail";
  if (/(salon|ambiance|interieur|adresse)/.test(text)) return "pm-frame--wide";
  return "pm-frame--portrait";
};

const PhotoMosaic = ({
  photos = [],
  variant = "editorial",
  emptyTitle = "Photos a venir",
  emptyText = "Le salon ajoutera prochainement de nouvelles images pour presenter ses coupes, finitions et inspirations.",
}) => {
  const visiblePhotos = photos.filter(photo => getPhotoSrc(photo));

  if (!visiblePhotos.length) {
    return (
      <div className={`pm-empty pm-empty--${variant}`}>
        <strong>{emptyTitle}</strong>
        <p>{emptyText}</p>
      </div>
    );
  }

  return (
    <div className={`pm-grid pm-grid--${variant}`}>
      {visiblePhotos.map((photo, index) => {
        const title = getPhotoTitle(photo, index);
        const category = photo.category || photo.label || "";
        const description = photo.description || photo.caption || "";

        return (
          <article
            className={`pm-card pm-card--${index % 8} ${getFrameClass(photo)}`}
            key={photo.id || `${title}-${index}`}
          >
            <img src={getPhotoSrc(photo)} alt={title} loading="lazy" />
            <div className="pm-caption">
              {category && <span className="pm-category">{category}</span>}
              <h3>{title}</h3>
              {description && <p>{description}</p>}
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default PhotoMosaic;
